import { StyleSheet } from '../react-native-components';

export const emojiMapStyling = theme => {
  return StyleSheet.create({
    container: {
      position: 'relative'
    },
    subIcon: {
      position: 'absolute',
      bottom: -10,
      left: -5,
      backgroundColor: 'white',
      borderRadius: 10,
      width: 20,
      height: 20,
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 3
    }
  });
};
